import React from "react";
import * as moment from "moment";
import {
  masterType,
  cityMasterTemplateStrings,
  agencyMasterTemplateStrings,
  depotMasterTemplateStrings,
  operatorViewTemplateStrings,
  countryMasterTemplateStrings,
  cameraHeadingsInView,
  serviceCategoryViewTemplateStrings,
  ViewLanguageMasterTemplateStrings,
  SeatingLayoutTemplateStrings,
  ownerMasterTemplateStrings
} from '../../utils';
import { EpochtoEpochTZ, renderValueByKey } from "../../../../../shared/utils";
import CityView from './CityView'
import chair from "./../../../../../assets/images/armChair.png";
import steering from "../../../../../assets/images/steering-wheel.png"
import PropTypes from "prop-types";

const CurrencySymbol = ({ value }) => (
  <span style={{ fontFamily: "DejaVu Sans" }}>{value}</span>
);

CurrencySymbol.propTypes = {
  value: PropTypes.any,
};

export const MasterInfoItem = (props) => {
  const templateStrings = {
    [masterType.city]: cityMasterTemplateStrings,
    [masterType.agency]: agencyMasterTemplateStrings,
    [masterType.operator]: operatorViewTemplateStrings,
    [masterType.depot]: depotMasterTemplateStrings,
    [masterType.country]: countryMasterTemplateStrings,
    [masterType.owner]: ownerMasterTemplateStrings,
    [masterType.camera]: cameraHeadingsInView,
    [masterType.serviceCategory]: serviceCategoryViewTemplateStrings,
    [masterType.language]:ViewLanguageMasterTemplateStrings,
    [masterType.seatingLayout]:SeatingLayoutTemplateStrings
  };

  const renderCityNames = () => {
    const { data:info,onClose,initiateNotification,activeTab,fetchServiceReportOnUpsertOfAgency,onComplete } = props.cityViewProps;
    const { value:tableData } = props;
    return <CityView data={{tableData,info,onClose,initiateNotification,activeTab,fetchServiceReportOnUpsertOfAgency,onComplete}} />
  };

  

  const renderCellContent = (cell) => {
    if (cell === '-') {
      return <div style={{ width: 30, height: 30 }}></div>;
    } else if (cell === '0') {
      return (
        <img
          src={steering}
          alt="steering"
          title={cell}
          className="seat-img"
        />
      );
    } else {
      return (
        <>
          <img
            src={chair}
            alt="seat"
            title={cell}
            className="seat-img"
          />
          <p className="layout-text">{cell}</p>
        </>
      );
    }
  };


  const getLayout = (value) => {
    if (!Array.isArray(value)) {
      return (
        <div className="layout-error">
          Invalid layout
        </div>
      );
    }

    const rotatedLayout = value[0].map((_, colIndex) =>
      value.map(row => row[colIndex])
    ).reverse();

    return (
      <div className="layout-container">
        {rotatedLayout.map((row, rowIndex) => (
          <div key={`row-${row.map(cell => cell.id || cell).join('-')}`} className="flex">
            {row.map((cell, colIndex) => (
              <div
                key={`cell-${rowIndex}-${colIndex}-${cell}`}
                className="bus-row"
              >
                {renderCellContent(cell)}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const formatBooleanString = (value) => {
    if (value === 'true') return 'Yes';
    if (value === 'false') return 'No';
    return 'N/A';
  };

  const formatters = {
    city: (value) => renderValueByKey(value, 'name'),
    status: (value) => value ? 'Active' : 'Inactive',
    isActive: (value) => value ? 'Active' : 'Inactive',
    operatorVerified: (value) => value ? 'Yes' : 'No',
    profilePercent: (value) => value.toString() + '%',
    createAt: (value) => value ? moment(new Date(EpochtoEpochTZ(parseInt(value), localStorage.getItem('timeZone')))).format('DD/MM/YYYY') : 'NA',
    updatedAt: (value) => value ? moment(new Date(EpochtoEpochTZ(parseInt(value), localStorage.getItem('timeZone')))).format('DD/MM/YYYY') : 'NA',
    createdAt: (value) => value ? moment(new Date(EpochtoEpochTZ(parseInt(value), localStorage.getItem('timeZone')))).format('DD/MM/YYYY') : 'NA',
    lastOnlineTime: (value) => value ? moment.utc(value).local().format('DD/MM/YYYY hh:mm:ss A') : 'NA',
    languages: (value) => renderValueByKey(value, 'language'),
    operator: (value) => renderValueByKey(value, 'id'),
    layout: (value) => getLayout(value),
    passwordMismatch: (value) => formatBooleanString(value),
    sdCardPresent: (value) => formatBooleanString(value),
  };

  const renderValue = () => {
    const { label, value } = props;
    let effectiveLabel = label;
    if (label === 'operators') {
      effectiveLabel = 'operator';
    } else if (label === 'cities') {
      effectiveLabel = 'city';
    }

    if (effectiveLabel === 'currencySymbol') {
      return <CurrencySymbol value={value} />;
    }

    const formatter = formatters[effectiveLabel];

    if (formatter) {
      return formatter(value);
    }

    return value?.name ? value.name : value;
  };

  const shouldRenderValue = () => {
    const { value, label } = props;
    let effectiveLabel = label;
    if (label === 'operators') {
      effectiveLabel = 'operator';
    } else if (label === 'cities') {
      effectiveLabel = 'city';
    }

    return (
      (value && templateStrings[props.masterType][effectiveLabel]) ||
      effectiveLabel === 'status' ||
      effectiveLabel === 'isActive' ||
      effectiveLabel === 'operatorVerified' ||
      effectiveLabel === 'profilePercent' ||
      effectiveLabel === 'passwordMismatch' ||
      effectiveLabel === 'sdCardPresent'
    );
  };
  // determine label key (treat `operators` as `operator` and `cities` as `city` for templates)
  let labelKey = props.label;
  if (props.label === 'operators') {
    labelKey = 'operator';
  } else if (props.label === 'cities') {
    labelKey = 'city';
  }
  return (
    <div className="row" style={{ display: 'flex!important' }}>
      {shouldRenderValue() && (
        <div  className="flex">
          {!['agencyCategoryDto','agencyProviderDto'].includes(props.label) && (
            <span className="info-label">{templateStrings[props.masterType][labelKey]} :</span>
          )}
          {!['agencyCategoryDto','agencyProviderDto'].includes(props.label) && <span className="info-value">{renderValue()}</span>}
          {['agencyCategoryDto','agencyProviderDto'].includes(props.label) && renderCityNames()}
        </div>
      )}
    </div>
  );
};



MasterInfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  masterType: PropTypes.string.isRequired,
  cityViewProps: PropTypes.shape({
    data: PropTypes.object,
    onClose: PropTypes.func,
    initiateNotification: PropTypes.func,
    activeTab: PropTypes.string,
    fetchServiceReportOnUpsertOfAgency: PropTypes.func,
    onComplete: PropTypes.func,
  }),
};
